import styled from 'styled-components';

const UserBoxInfo = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export default UserBoxInfo;
